import { useSearchParams } from 'react-router-dom';
import { ReportFiltersBar } from '@/components/reports/ReportFiltersBar';
import { ReportSubNav } from '@/components/reports/ReportSubNav';
import { ReportSelector } from '@/components/reports/ReportSelector';
import { reportsForTab, resolveReport } from '@/components/reports/reportRegistry';
import { useReportFilters } from '@/components/reports/useReportFilters';

const TAB = 'menu' as const;

export default function MenuReportPage() {
  const filters = useReportFilters(7);
  const {
    restaurants,
    selectedRestaurantId,
    setSelectedRestaurantId,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
  } = filters;

  const [searchParams, setSearchParams] = useSearchParams();
  const selected = resolveReport(TAB, searchParams.get('report'));
  const { Component } = selected;

  return (
    <div className="space-y-6">
      <ReportSubNav />

      <div className="flex flex-wrap items-center justify-between gap-4">
        <h1 className="text-2xl font-bold text-gray-900">Menu Reports</h1>
        <ReportSelector
          reports={reportsForTab(TAB)}
          value={selected.id}
          onChange={(id) => setSearchParams({ report: id }, { replace: true })}
        />
      </div>

      <ReportFiltersBar
        restaurants={restaurants}
        selectedRestaurantId={selectedRestaurantId}
        onRestaurantChange={setSelectedRestaurantId}
        startDate={startDate}
        onStartDateChange={setStartDate}
        endDate={endDate}
        onEndDateChange={setEndDate}
      />

      <Component filters={filters} />
    </div>
  );
}
